/**
 * Checks if the window is wide enough to be considered a desktop view.
 * This is based on a CSS media query and `window.matchMedia`.
 *
 * @param {number} [minWidthDesktop=840] The minimum width in pixels for a desktop view.
 * @returns {boolean} True if the window width is equal to or greater than the specified minimum width, otherwise false.
 */
export function isDesktop(minWidthDesktop = 840) {
  return window.matchMedia(`(min-width: ${minWidthDesktop}px)`).matches;
}
